import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { modelTypeData } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
let ModelType = class ModelType extends Vue {
    value;
    disabled;
    modelTypeData = modelTypeData;
    iconFontSize = `fontSize:1.5rem`;
    get modelType() {
        return this.value;
    }
    set modelType(val) {
        this.$emit('input', val);
    }
};
__decorate([
    Prop({ type: String })
], ModelType.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ModelType.prototype, "disabled", void 0);
ModelType = __decorate([
    Component({
        name: 'ModelType',
        components: {},
        i18n: {
            messages: {
                en: {
                    modelTypeText: 'Model Type',
                    modeTip: 'The head point model is suitable for scenes with high crowd density. The head and shoulder model is suitable for scenes with low crowd density, but the recognition accuracy is higher',
                },
                zh: {
                    modelTypeText: '模型类型',
                    modeTip: '人头点模型适用于人群密度较高的场景；头肩模型适用于人群密度较低的场景，但识别精度较高',
                },
            },
        },
    })
], ModelType);
export default ModelType;
